import React from "react";
import {
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Box,
  IconButton,
} from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";
import MoreVertIcon from "@mui/icons-material/MoreVert";

function FolderDrawerListItem({
  folder,
  selectedFolder,
  onFolderSelect,
  onMenuOpen,
}) {
  return (
    <ListItemButton
      key={folder.folderId}
      selected={selectedFolder?.folderId === folder.folderId}
      onClick={() => onFolderSelect(folder)}
      sx={{
        pl: 4,
        borderBottom: "1px solid #eee",
        transition: "background 0.18s, color 0.18s",
        color: "#222b45",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "&.Mui-selected": {
          bgcolor: "#c3e3fa",
          color: "#222b45",
          fontWeight: 700,
          borderRight: "3.5px solid #4294ff",
          "&:hover": {
            bgcolor: "#b0d4fb",
          },
        },
        "&:hover": {
          bgcolor: "#f5f9ff",
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <ListItemIcon sx={{ minWidth: 32, color: "#4294ff" }}>
          <FolderIcon />
        </ListItemIcon>
        <ListItemText primary={folder.folderName} />
      </Box>
      {selectedFolder?.folderId === folder.folderId && (
        <IconButton
          edge="end"
          size="small"
          onClick={(e) => onMenuOpen(e, folder)}
          aria-label="folder options"
        >
          <MoreVertIcon />
        </IconButton>
      )}
    </ListItemButton>
  );
}

export default FolderDrawerListItem;
